import { render, staticRenderFns } from "./SwitchPlan.vue?vue&type=template&id=33c21abe&scoped=true"
import script from "./SwitchPlan.vue?vue&type=script&lang=js"
export * from "./SwitchPlan.vue?vue&type=script&lang=js"
import style0 from "./SwitchPlan.vue?vue&type=style&index=0&id=33c21abe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c21abe",
  null
  
)

export default component.exports